import Swiper from 'swiper'
import SwiperCore, { Navigation } from 'swiper/core'

SwiperCore.use([Navigation])

export default class ImageNavigation {
  constructor(component) {
    this.dom = {
      $component: component,
      $slides: component.querySelectorAll('.js-imageNavigationSlide'),
    }
    this.state = {

    }
    this.mount()
    this.bindToWindow()
  }

  mount() {
    this.initSlider()
  }

  initSlider() {
    const { dom } = this

    const swiperConfig = {
      slidesPerView: 'auto',
      breakpoints: {
        1110: {
          loop: true,
          slidesPerView: 6,
          allowTouchMove: false,
        }
      }
    }

    if (dom.$slides.length > 6) {
      swiperConfig.navigation = {
        prevEl: '.js-ImageNavigationSwiperButtonPrev',
        nextEl: '.js-ImageNavigationSwiperButtonNext',
      }
    }

    const swiper = new Swiper('.js-imageNavigationSwiperContainer', swiperConfig)
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.ImageNavigation = this
  }
}
